import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Library, OPTIONS } from '../library';

@Injectable({
  providedIn: 'root'
})
export class XenditService {

  constructor(private http: HttpClient) { }

  xenditPay(amount: any, ID: any, planID, successURL: any, failURL: any, connectedEmail: any, fname: any) {
    const queryParams = new HttpParams()
      .set('planID', planID)
      .set('amount', amount)
      .set('successURL', successURL)
      .set('failURL', failURL)
      .set('email', connectedEmail)
      .set('fname', fname)
      .set('fee', 0)

    return this.http.post<any>(Library.API_ENDPOINT + `account/xendit-create/${ID}`, {}, { params: queryParams })
  }

  xenditPayCommon(amount: any, ID: any, planID, successURL: any, failURL: any, connectedEmail: any, fname: any, userId: any) {
    const queryParams = new HttpParams()
      .set('planID', planID)
      .set('amount', amount)
      .set('successURL', successURL)
      .set('failURL', failURL)
      .set('email', connectedEmail)
      .set('fname', fname)
      .set('fee', 0)
      .set('userId', userId);

    return this.http.post<any>(Library.API_ENDPOINT + `common/xendit-create/${ID}`, {}, { params: queryParams })
  }

  xenditPayEmployee(amount: any, UUID: any, employeeCount: any, successURL: any, failURL: any, connectedEmail: any, fname: any) {
    const queryParams = new HttpParams()
      .set('UUID', UUID)
      .set('employeeCount', employeeCount)
      .set('amount', amount)
      .set('successURL', successURL)
      .set('failURL', failURL)
      .set('email', connectedEmail)
      .set('fname', fname)
      .set('fee', 0)

    return this.http.post<any>(Library.API_ENDPOINT + `account/xendit-create_employee`, {}, { params: queryParams })
  }

  getEmployeePrice() {
    return this.http.get<any>(Library.API_ENDPOINT + 'account/get_employee_price');
  }

  getXenditSuccessURL(URL: string) {
    const params = new HttpParams().set('URL', URL);
    return this.http.get<any>(Library.API_ENDPOINT + 'account/get_xendit_succcessURL', { params });
  }

    getXenditSuccessURLCommon(URL: string, userId: any) {
    const params = new HttpParams().set('URL', URL).set('userId', userId);
    return this.http.get<any>(Library.API_ENDPOINT + 'common/get_xendit_succcessURL', { params });
  }

  getXenditSuccessURLEmployee(URL: string) {
    const params = new HttpParams().set('URL', URL);
    return this.http.get<any>(Library.API_ENDPOINT + 'account/get_xendit_succcessURL_employee', { params });
  }

  insertAdditionalEmployee(count: number) {
    const params = new HttpParams().set('additional', count);
    return this.http.post<any>(Library.API_ENDPOINT + 'account/additional_employee', {}, { params });
  }
}
